/**
 * Ponto de extensão para módulos EXCLUSIVOS de um cliente da plataforma.
 *
 * Regra da casa: o produto base nunca é copiado. Se um cliente precisar de algo que só
 * faz sentido para ele, o código fica em tenants/<cliente>/web/index.tsx e é carregado
 * só quando aquele cliente acessa (os demais nem baixam esse código).
 *
 * Exemplo de tenants/<cliente>/web/index.tsx:
 *   import type { TenantExtension } from '../../../apps/web/src/tenants/registry';
 *   const ext: TenantExtension = {
 *     navItems: [{ path: '/minha-tela', label: 'Minha tela', icon: 'chart' }],
 *     routes: [{ path: '/minha-tela', element: <MinhaTela /> }],
 *   };
 *   export default ext;
 */
import type { ReactNode } from 'react';
import type { IconName } from '@dotapps/ui';
import type { Role } from '@dotapps/core';

export interface TenantExtension {
  /** `roles`: perfis que veem o item (sem a lista: todos) */
  navItems?: Array<{ path: string; label: string; icon: IconName; roles?: Role[] }>;
  routes?: Array<{ path: string; element: ReactNode }>;
}

const modules = import.meta.glob<{ default: TenantExtension }>('../../../../tenants/*/web/index.tsx');

export async function loadTenantExtension(slug: string): Promise<TenantExtension> {
  const entry = Object.entries(modules).find(([p]) => p.includes(`/tenants/${slug}/web/`));
  if (!entry) return {};
  try {
    return (await entry[1]()).default ?? {};
  } catch (err) {
    console.error('Falha ao carregar módulo do cliente', err);
    return {};
  }
}
